var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "modal-mask",
        on: {
          click: function($event) {
            _vm.$emit("close")
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-container",
            style: "width: " + _vm.width,
            on: {
              click: function($event) {
                _vm.$emit("close")
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-content",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [_vm._t("default")],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-701ac82d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-701ac82d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = null
// module chunks = 